import type {
  EffectTwoDirections,
  SchemaGroup,
  ScrollEffectConfig,
  ScrollEffectParams,
  UnitLengthPercentage,
} from '../types';
import {
  range,
  directionTwoSides as direction,
  scrollOffsetFull,
  rangeInOut,
  screenEnter,
  screenLeave,
  screenCenter,
} from './baseParams';

export interface PanScroll extends ScrollEffectParams {
  direction: EffectTwoDirections;
  startFromOffScreen: Boolean;
  distance: UnitLengthPercentage;
}

const name = 'PanScroll';
const groups: SchemaGroup[] = ['scroll', 'animation'];

export const config: ScrollEffectConfig<PanScroll> = {
  name,
  groups,
  range: { ...range },
  schema: {
    in: {
      start: { ...screenEnter },
      end: { ...screenCenter },
      direction: { ...direction, default: 'left' },
      startFromOffScreen: {
        type: 'boolean',
        default: true,
      },
      distance: {
        type: 'number-with-unit',
        min: 0,
        max: 800,
        step: 1,
        default: { value: 400, type: 'px' },
        mobileDefault: { value: 50, type: 'px' },
        units: ['px'],
      },
    },
    out: {
      start: { ...screenCenter },
      end: { ...screenLeave },
      direction: { ...direction, default: 'left' },
      startFromOffScreen: {
        type: 'boolean',
        default: true,
      },
      distance: {
        type: 'number-with-unit',
        min: 0,
        max: 800,
        step: 1,
        default: { value: 400, type: 'px' },
        mobileDefault: { value: 50, type: 'px' },
        units: ['px'],
      },
    },
    continuous: {
      start: { ...screenEnter },
      end: { ...screenLeave },
      direction: { ...direction, default: 'left' },
      startFromOffScreen: {
        type: 'boolean',
        default: true,
      },
      distance: {
        type: 'number-with-unit',
        min: 0,
        max: 800,
        step: 1,
        default: { value: 400, type: 'px' },
        mobileDefault: { value: 50, type: 'px' },
        units: ['px'],
      },
    },
  },
} as const;

export const responsiveConfig: ScrollEffectConfig<PanScroll> = {
  name,
  groups,
  range: { ...rangeInOut },
  schema: {
    in: {
      start: { ...scrollOffsetFull },
      end: { ...scrollOffsetFull, default: 50 },
      direction: { ...direction, default: 'left' },
      startFromOffScreen: {
        type: 'boolean',
        default: true,
      },
      distance: {
        type: 'number-with-unit',
        min: 0,
        max: 800,
        step: 1,
        default: { value: 400, type: 'px' },
        units: ['percentage', 'px', 'vh', 'vw'],
      },
    },
    out: {
      start: { ...scrollOffsetFull, default: 50 },
      end: { ...scrollOffsetFull, default: 100 },
      direction: { ...direction, default: 'left' },
      startFromOffScreen: {
        type: 'boolean',
        default: true,
      },
      distance: {
        type: 'number-with-unit',
        min: 0,
        max: 800,
        step: 1,
        default: { value: 400, type: 'px' },
        units: ['percentage', 'px', 'vh', 'vw'],
      },
    },
  },
  hide: true,
} as const;
